
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Breadcrumb',
  props: {
    url1: {
      type: String,
      required: true,
    },
    text1: {
      type: String,
      required: true,
    },
    text2: {
      type: String,
    },
  },
  setup() {
  },
})
